import React from "react";
import styles from "./styles.module.css";

function EMandateFailure() {
  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <img src="/feemonklogo.png" alt="" className={styles.logo} />
        <div className={styles.iconWrapper}>
          <svg
            viewBox="0 0 64 64"
            className={styles.icon}
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="32" cy="32" r="32" fill="#fdecea" />
            <path
              d="M20 20l24 24M44 20L20 44"
              stroke="#e74c3c"
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div className={styles.textContainer}>
          <p className={styles.heading}>Process Failed</p>
          <p className={styles.subText}>
            Your eMandate Process could not be completed.
          </p>
          <p className={styles.closeText}>
            Please try again or contact us at{" "}
            <a href="mailto:hello@feemonk.com" className={styles.link}>
              hello@feemonk.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default EMandateFailure;
